import * as Yup from 'yup';

export const isNoSelected = (v: any) => {
    if (!v) return false;
    if (typeof v === 'string') return v.toLowerCase() === 'no';
    if (typeof v === 'object') {
        const id = String(v.id ?? '').toLowerCase();
        const name = String(v.name ?? v.label ?? '').toLowerCase();
        return id === 'no' || name === 'no';
    }
    return false;
};

export const initialValues: any = {
    area: '',
    functionary: '',
    emailFunctionary: '',
    functionaryExtension: '',
    functionaryAttendedCall: '',
    templateEmail: '',
};

export const validationSchema = Yup.object({
    functionaryAttendedCall: Yup.mixed().required(
        'El contacto de éxito es obligatorio'
    ),
    templateEmail: Yup.string().when(
        'functionaryAttendedCall',
        (val, schema) => {
            return isNoSelected(val)
                ? schema.required(
                    'La plantilla de correo es obligatoria si No atendió'
                )
                : schema.notRequired();
        }
    ),
});
